import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import FourStageSystem from './components/FourStageSystem';
import ShopSection from './components/ShopSection';
import BundleSection from './components/BundleSection';
import ComparisonSection from './components/ComparisonSection';
import InfoSection from './components/InfoSection';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-50 overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <FourStageSystem />
        <ShopSection />
        <BundleSection />
        <ComparisonSection />
        <InfoSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;